import React, { useState } from "react";
import { Row, Col, Container, Fade } from "react-bootstrap";
import transparency from "../assets/image/svg/transparency.svg";
import boost from "../assets/image/svg/boost.svg";
import gogreen from "../assets/image/svg/gogreen.svg";
import usersegmentation from "../assets/image/svg/usersegmentation.svg";
import pfm from "../assets/image/svg/pfm.svg";
import unbanked from "../assets/image/svg/unbanked.svg";
import future from "../assets/image/svg/future.svg";

const UseCases = () => {
  const [active, setActive] = useState(1);

  return (
    <div className="pb-md-19 pt-md-2 pt-5  ">
      <Container>
        <nav className="pb-12 ">
          <div
            className="nav gr-nav-tabs"
            id="nav-tab"
            role="tablist"
            style={{
              flexWrap: "nowrap",
              overflowX: "scroll",
              whiteSpace: "nowrap",
              margin: "auto",
              marginBottom: "0",
            }}
          >
            <div style={{ display: "flex", margin: "auto" }}>
              <div
                data-aos="fade-right"
                data-aos-duration="700"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  href="/#"
                  //   style = {{textAlign:'center', margin:'auto',position: 'absolute',left:'50%',right:'50%'}}
                  className={`nav-item nav-link gr-text-9 font-weight-bold  ${
                    active === 1 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 1}
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(1);
                  }}
                >
                  Transparency
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 2 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 2}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(2);
                  }}
                >
                  Go Green
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="1300"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 3 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 3}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(3);
                  }}
                  // data-aos="fade-up"
                  // data-aos-duration="700"
                  // data-aos-delay="800"
                >
                  Boost Topline
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="1600"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 4 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 4}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(4);
                  }}
                >
                  Unbanked
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="1900"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 5 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 5}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(5);
                  }}
                >
                  User Segmentation
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="2200"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 6 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 6}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(6);
                  }}
                >
                  PFM
                </a>
              </div>
              <div
                data-aos="fade-right"
                data-aos-duration="2500"
                data-aos-delay="400"
                style={{ position: "relative", marginRight: "10px" }}
              >
                <a
                  className={`nav-item nav-link gr-text-9 font-weight-bold ${
                    active === 7 ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={active === 7}
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActive(7);
                  }}
                  // data-aos="fade-up"
                  // data-aos-duration="700"
                  // data-aos-delay="1600"
                >
                  Future Proof
                </a>
              </div>
            </div>
          </div>
        </nav>
        <div className="tab-content " id="nav-tabContent">
          <Fade
            in={active === 1}
            role="tabpanel"
            className={`tab-pane ${active === 1 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6">
                    <p className="gr-text-9   showcase-adjust ">
                      Offer users transparency on their spending, by breaking it
                      down into 50+ granular income and expense categories.
                    </p>
                  </Col>
                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image"
                        data={transparency}
                        aria-labelledby="user transparency"
                        alt="feature"
                        style={{}}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 2}
            role="tabpanel"
            className={`tab-pane ${active === 2 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6">
                    <p className="gr-text-9   showcase-adjust">
                      Let users know about their environmental impact. Our
                      engine analyzes individual transactions for you and your
                      users to go green.
                    </p>
                  </Col>
                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image"
                        data={gogreen}
                        alt="feature"
                        aria-labelledby="feature"
                        style={{}}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 3}
            role="tabpanel"
            className={`tab-pane ${active === 3 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6">
                    <p className="gr-text-9   showcase-adjust">
                      Recommend automatically the right banking product to the
                      right customer at the right time across your channels
                      (mobile, website and in branches).
                    </p>
                  </Col>
                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image"
                        data={boost}
                        aria-labelledby="automatic recommendation"
                        alt="feature"
                        style={{}}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 4}
            role="tabpanel"
            className={`tab-pane ${active === 4 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6" sm="12" xs="12">
                    <p className="gr-text-9   showcase-adjust">
                      Lend to the unbanked with the power of alternative data.
                    </p>
                  </Col>

                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image-2"
                        data={unbanked}
                        aria-labelledby="lend to unbanked"
                        alt="feature"
                        style={{ paddingBottom: "146px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 5}
            role="tabpanel"
            className={`tab-pane ${active === 5 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6" sm="12" xs="12">
                    <p className="gr-text-9   showcase-adjust">
                      Know your users better from their transaction data.
                    </p>
                  </Col>
                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image-2"
                        aria-labelledby="know your users better"
                        data={usersegmentation}
                        alt="feature"
                        style={{ paddingBottom: "53px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 6}
            role="tabpanel"
            className={`tab-pane ${active === 6 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6" sm="12" xs="12">
                    <p className="gr-text-9   showcase-adjust">
                      Bring true PFM features to your banking app.
                    </p>
                  </Col>

                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image"
                        data={pfm}
                        alt="feature"
                        aria-labelledby="true pfm"
                        style={{}}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
          <Fade
            in={active === 7}
            role="tabpanel"
            className={`tab-pane ${active === 7 ? "active" : ""}`}
          >
            <div>
              <div>
                <Row>
                  <Col md="6">
                    <p className="gr-text-9   showcase-adjust">
                      Make your banking mobile app future-proof with AI.
                    </p>
                  </Col>
                  <Col md="6">
                    <div className="widget-icon gr-text-4 text-blue   mb-7 mb-md-0">
                      <object
                        className="showcase-adjust-image"
                        data={future}
                        aria-labelledby="future proof"
                        alt="feature"
                        style={{}}
                      />
                      {/* done */}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
        </div>
      </Container>
    </div>
  );
};

export default UseCases;
